import { render, staticRenderFns } from "./series_list.vue?vue&type=template&id=f98eb0bc"
import script from "./series_list.vue?vue&type=script&lang=js"
export * from "./series_list.vue?vue&type=script&lang=js"
import style0 from "./series_list.vue?vue&type=style&index=0&id=f98eb0bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports